import { toast } from "react-toastify";

export function copyTypeableLine(text: string): void {
  navigator?.clipboard?.writeText(text);
  toast?.info(`Código copiado: ${text}`);
}
